import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AdminConfigService } from '@modeso/dgoods-lib-admin-fe';
import { FraudRuleBaseDTO, FraudRulesProductLinesDTO } from '@modeso/types__dgoods-cart';
import { CreateFraudRuleBaseRequestDTO } from '@modeso/types__dgoods-cart/dist/interfaces/fraudRules/base/CreateFraudRuleBaseRequestDTO.interface';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FraudRulesService {
    private readonly apiUrl: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(AdminConfigService) private readonly config,
    ) {
        // Use the apiGateway from the config and append the microservice path
        this.apiUrl = `${environment.modeso.apiGateway}cart/fraud-rules`;
    }

    getFraudRules(): Observable<FraudRuleBaseDTO[]> {
        return this.http.get<FraudRuleBaseDTO[]>(this.apiUrl);
    }

    createFraudRule(ruleData: CreateFraudRuleBaseRequestDTO): Observable<void> {
        return this.http.post<void>(this.apiUrl, ruleData);
    }

    enableFraudRule(id: string): Observable<void> {
        return this.http.patch<void>(`${this.apiUrl}/${id}/enable`, {});
    }

    disableFraudRule(id: string): Observable<void> {
        return this.http.patch<void>(`${this.apiUrl}/${id}/disable`, {});
    }

    deleteFraudRule(id: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }

    getAvailableProductLines(): Observable<FraudRulesProductLinesDTO> {
        return this.http.get<FraudRulesProductLinesDTO>(`${this.apiUrl}/getAvailableProductLines`);
    }

    updateFraudRule(id: string, ruleData: CreateFraudRuleBaseRequestDTO): Observable<void> {
        return this.http.put<void>(`${this.apiUrl}/${id}`, ruleData);
    }
}
